/** GP band thresholds — keep in sync with app/constants/menuBuilderCopy.js */
export const GP_THRESHOLDS = {
  greenMin: 75,
  amberMin: 65,
}

export const GP_COLOUR_GUIDE_TEXT = `Green = ${GP_THRESHOLDS.greenMin}%+ GP · Amber = ${GP_THRESHOLDS.amberMin}–74% GP · Red = below ${GP_THRESHOLDS.amberMin}% GP`

export const GP_BAND = {
  GREEN: 'green',
  AMBER: 'amber',
  RED: 'red',
  UNKNOWN: 'unknown',
}

export const parseGpPercent = grossProfit => {
  if (grossProfit === null || grossProfit === undefined || grossProfit === '') {
    return null
  }
  const parsed = parseFloat(String(grossProfit).replace(/%/g, '').trim())
  return Number.isFinite(parsed) ? parsed : null
}

export const getGpBand = gpPercent => {
  if (gpPercent === null) {
    return {
      key: GP_BAND.UNKNOWN,
      label: 'No GP%',
      color: '#595959',
      backgroundColor: '#f5f5f5',
    }
  }

  if (gpPercent >= GP_THRESHOLDS.greenMin) {
    return {
      key: GP_BAND.GREEN,
      label: 'Green',
      color: '#237804',
      backgroundColor: '#f6ffed',
    }
  }

  if (gpPercent >= GP_THRESHOLDS.amberMin) {
    return {
      key: GP_BAND.AMBER,
      label: 'Amber',
      color: '#ad6800',
      backgroundColor: '#fff7e6',
    }
  }

  return {
    key: GP_BAND.RED,
    label: 'Red',
    color: '#a8071a',
    backgroundColor: '#fff1f0',
  }
}

export const getGpBandByKey = bandKey => {
  if (bandKey === GP_BAND.GREEN) {
    return getGpBand(GP_THRESHOLDS.greenMin)
  }
  if (bandKey === GP_BAND.AMBER) {
    return getGpBand(GP_THRESHOLDS.amberMin)
  }
  if (bandKey === GP_BAND.RED) {
    return getGpBand(GP_THRESHOLDS.amberMin - 1)
  }
  return getGpBand(null)
}

export const formatGpDisplay = grossProfit => {
  const gp = parseGpPercent(grossProfit)
  const band = getGpBand(gp)
  const valueText =
    gp === null ? '—' : `${Number.isInteger(gp) ? gp : gp.toFixed(1)}%`

  return { gp, band, valueText }
}

const GP_BAND_CHIP_BORDERS = {
  green: '#b7eb8f',
  amber: '#ffd591',
  red: '#ffa39e',
  unknown: '#d9d9d9',
}

export const getGpBandChipStyle = gpPercent => {
  const band = getGpBand(gpPercent)

  return {
    color: band.color,
    backgroundColor: band.backgroundColor,
    border: `1px solid ${
      GP_BAND_CHIP_BORDERS[band.key] || GP_BAND_CHIP_BORDERS.unknown
    }`,
  }
}
